import React from 'react';
import { Button, Popover } from 'antd';
import { Container } from './Styled';
import { Flow } from '../../../../model/workflowEditor/flow/types';
import { AiOutlineControl, AiOutlineSave } from "react-icons/ai";
import { SlotManager } from './slotManager/SlotManager';
import BuilderContext from '../../../context/BuilderContext';
import { useDispatch } from 'react-redux';
import { saveFlowAction } from '../../../../business/actions/flowActions';

type OptionsMenuProps = {
  flow: Flow;
  onChange: (flow: Flow) => void;
};

export const OptionsMenu: React.FunctionComponent<OptionsMenuProps> = ({ flow, onChange }) => {
  const { builder } = React.useContext(BuilderContext);
  const slotManager = <SlotManager flow={flow} onChange={onChange}/>
  const dispatch = useDispatch();

  const onSave = () => {
    if(builder){
      flow.diagram = builder!.serializeDiagramToJson()
      dispatch(saveFlowAction.request(flow));
    }
  }

  return (
   <Container>
      <Popover trigger="click" placement="left" content={slotManager}>
        <Button size='large' icon={<AiOutlineControl size={24}/>} />
      </Popover>
      <Button size='large' onClick={() => onSave()} icon={<AiOutlineSave size={24}/>} />
   </Container>
  );
}

export default OptionsMenu;